import { useEffect, useState } from "react";

const KEY = "chemlab_offline_lessons";
const EVENT = "chemlab-offline-change";

const readAll = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
};
const writeAll = (map) => {
  localStorage.setItem(KEY, JSON.stringify(map));
  window.dispatchEvent(new Event(EVENT));
};
export const lessonKey = (year, order) => `${Number(year)}-${Number(order)}`;

export const getOfflineLesson = (year, order) => readAll()[lessonKey(year, order)] || null;

export function saveOfflineLesson({ lesson, content, excerpts }) {
  const map = readAll();
  map[lessonKey(lesson.year, lesson.order)] = { lesson, content, excerpts, saved_at: new Date().toISOString() };
  writeAll(map);
}

export function removeOfflineLesson(year, order) {
  const map = readAll();
  delete map[lessonKey(year, order)];
  writeAll(map);
}

export function clearOfflineLessons() { writeAll({}); }

export function useOfflineLessons() {
  const [items, setItems] = useState(() => Object.values(readAll()));
  useEffect(() => {
    const sync = () => setItems(Object.values(readAll()));
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener("storage", sync); };
  }, []);
  return items.sort((a, b) => (a.lesson.year - b.lesson.year) || (a.lesson.order - b.lesson.order));
}

export function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => { window.removeEventListener("online", up); window.removeEventListener("offline", down); };
  }, []);
  return online;
}
